import React, { useEffect, useState } from "react";
import "../../_css/TeacherManagement.css";
import { notifyError, notifySuccess } from "../helper/Toaster";
import {
  deleteAuthToken,
  isValidEmail,
  isValidPhoneNumber,
} from "../../utils/helper";
import { addTeacher, getAllSchools, getSchoolCodes } from "../../requests";
import { useNavigate } from "react-router-dom";
import SearchableDropdown from "../common/SearchableDropdown";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { provinces, schoolTypes ,grades, schoolPositions, subjects} from "../constants";

const AddTeacher = ({ fn }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [schools, setSchools] = useState([]);
  const [schoolCodes, setSchoolCodes] = useState([]);

  const [teacherData, setTeacherData] = useState({
    name: "",
    email: "",
    phone_number: "",
    school: "",
    province: "",
    school_level: "",
    position: "",
    grade: "",
    subject: "",
    school_code: "",
    school_location: "",
  });

  const handleChange = (e) => {
    if(e.target.name == "school_code"){
      //find object from schoolCodes array
      
      const schoolCodeObject = schoolCodes.find((el) => el.school_code == e.target.value);
      if(!schoolCodeObject){
        setTeacherData((p) => ({ ...p, school: "", school_location: "" ,school_code: e.target.value}));
        return;
      }
      setTeacherData((p) => ({ ...p, school_location: schoolCodeObject?.location, school: schoolCodeObject?.school_name ,school_code: e.target.value}));
      return;
    }
    setTeacherData({ ...teacherData, [e.target.name]: e.target.value });
  };

  const getSchools = async () => {
    try {
      const schoolRes = await getAllSchools();
      const uniqueSchools = schoolRes?.data?.schools.filter(
        (e) => e != "Other"
      ); // Filter out 'Other' school
      setSchools(uniqueSchools);
    } catch (error) {
      // notifyError("Error fetching schools");
    }
  };

  const validate = () => {
    // validations for primary fields like name, email, province, school
    if (!teacherData.name) {
      notifyError("Please enter a name");
      return false;
    }
    const nameRegex = /^[A-Za-z ]{1,30}$/;

    if (!nameRegex.test(teacherData.name)) {
      notifyError("Please enter a name that contains only letters");
      return false;
    }

    if (!teacherData.email) {
      notifyError("Please enter an email address");
      return false;
    }

    if (!isValidEmail(teacherData.email)) {
      notifyError("Please enter an valid email address");
      return false;
    }

    if (!teacherData.phone_number) {
      notifyError("Please enter a phone number");
      return false;
    }

    if (!isValidPhoneNumber(teacherData.phone_number)) {
      notifyError("Please enter a phone number of 10 digits");
      return false;
    }

    if (!teacherData.school_code ) {
      notifyError("Please select the school code");
      return false;
    }

    if (!teacherData.province) {
      notifyError("Please select the province");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }

    dispatch(startLoader());

    try {
      const response = await addTeacher(teacherData);

      if (response.status < 400) {
        notifySuccess(response?.data?.message || "Teacher added successfully");
        setTeacherData({
          name: "",
          email: "",
          phone_number: "",
          school: "",
          province: "",
          school_level: "",
          position: "",
          grade: "",
          subject: "",
          school_code: "",
          school_location: "",
        });

        fn();
      }
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error ||
            "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      }
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader());
    }
  };

  const getAllSchoolCodes = async () => {
    try {
      const schoolCodesRes = await getSchoolCodes();

      if (schoolCodesRes.status == 200) {
        setSchoolCodes(schoolCodesRes?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching school codes:", error);
    }
  };


  useEffect(() => {
    getSchools();
    getAllSchoolCodes();
  }, []);

  return (
    <div className="teacher-add-main">
      <div className="add-teacher-container">
        <div className="add-teacher-head">
          <div> Add a Teacher </div>
          <img
            style={{ cursor: "pointer" }}
            onClick={() => fn()}
            src="/close.svg"
          />
        </div>
        <div className="add-teacher-form">
          <div className="add-teacher-input-field" style={{ width: "437px" }}>
            <label className="add-teacher-label">Enter Full name</label>
            <input
              type="text"
              className="add-teacher-input"
              placeholder="Name"
              name="name"
              value={teacherData.name}
              onChange={handleChange}
              maxLength={30}
            />
          </div>
          <div className="di-flex" style={{ width: "437px" }}>
            <div className="add-teacher-input-field">
              <label className="add-teacher-label">Mail</label>
              <input
                type="email"
                className="add-teacher-input"
                placeholder="example@domain.com"
                name="email"
                value={teacherData.email}
                onChange={handleChange}
              />
            </div>
            <div className="add-teacher-input-field">
              <label className="add-teacher-label">Phone</label>
              <input
                type="number"
                className="add-teacher-input no-spinner"
                placeholder="Phone"
                name="phone_number"
                value={teacherData.phone_number}
                onChange={handleChange}
                onInput={(e) => {
                  if (e.target.value.length > 10) {
                    e.target.value = e.target.value.slice(0, 10);
                  }
                }}
              />
            </div>
          </div>
        

          <div className="di-flex" style={{ width: "437px" }}>
            <div className="add-teacher-input-field">
              <label className="add-teacher-label">School Code</label>
              <SearchableDropdown
                allowManualEntry={true}
                options={[...schoolCodes.map((e) => e.school_code)]}
                selected={teacherData.school_code}
                setSelected={(e) =>
                  handleChange({ target: { name: "school_code", value: e } })
                }
              />
            </div>
          
            <div className="add-teacher-input-field">
              <label className="add-teacher-label">School</label>
             <input
                type="text"
                className="add-teacher-input"
                placeholder="School"
                name="school"
                value={teacherData.school}
                readOnly={true}
              />
            </div>
          </div>
          <div className="di-flex" style={{ width: "437px" }}>
          <div className="add-teacher-input-field">
              <label className="add-teacher-label">School Location</label>
              <input
                type="text"
                className="add-teacher-input"
                placeholder="School Location"
                name="school_location"
                value={teacherData.school_location}
                onChange={handleChange}
                readOnly={true}
              />
            </div>

            <div className="add-teacher-input-field">
              <label className="add-teacher-label">Province</label>
              <SearchableDropdown
                options={[...provinces]}
                selected={teacherData.province}
                setSelected={(e) =>
                  setTeacherData((p) => ({ ...p, province: e }))
                }
              />
            </div>
          </div>
          <div className="di-flex" style={{ width: "437px" }}>
            <div className="add-teacher-input-field">
              <label className="add-teacher-label">School Type</label>
              <SearchableDropdown
                options={[...schoolTypes]}
                selected={teacherData.school_level}
                setSelected={(e) =>
                  setTeacherData((p) => ({ ...p, school_level: e }))
                }
              />
            </div>
            <div className="add-teacher-input-field">
              <label className="add-teacher-label">Position</label>
              <SearchableDropdown
                options={[...schoolPositions]}
                selected={teacherData.position}
                setSelected={(e) =>
                  setTeacherData((p) => ({ ...p, position: e }))
                }
              />
            </div>
          </div>
          <div className="di-flex" style={{ width: "437px" }}>
            <div className="add-teacher-input-field">
              <label className="add-teacher-label">Grade</label>
              <SearchableDropdown
                options={[...grades]}
                selected={teacherData.grade}
                setSelected={(e) => setTeacherData((p) => ({ ...p, grade: e }))}
                type="number"
                allowManualEntry={false}
              />
            </div>
            <div className="add-teacher-input-field">
              <label className="add-teacher-label">Subject</label>
              <SearchableDropdown
                options={[...subjects]}
                selected={teacherData.subject}
                setSelected={(e) =>
                  setTeacherData((p) => ({ ...p, subject: e }))
                }
              />
            </div>
          </div>
        </div>
        <div className="add-teacher-submit">
          <button className="add-teacher-submit-btn" onClick={handleSubmit}>
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTeacher;
